export default "__VITE_ASSET__4CO8nB7W__"